import React from 'react';
/**
 * DjayAvatar part — arms per emotion (with small-size stubs fallback).
 * Verbatim extraction of the former `renderArms()`.
 */
import type { DjayEmotion, VariantColorScheme } from '../types';
interface ArmsProps {
  emotion: DjayEmotion;
  colors: VariantColorScheme;
  showFullArms: boolean;
  showArmStubs: boolean;
}
export function Arms({
  emotion,
  colors,
  showFullArms,
  showArmStubs
}: ArmsProps) {
  if (!showFullArms && !showArmStubs) return null;
  if (showArmStubs) return <g className="djay-arms-stubs" data-id="element-3368" data-mp="y8khtdly9vaw">
        <circle cx="38" cy="125" r="8" fill={colors.armColor} data-id="element-3369" data-mp="y7j5z6x414s4" />
        <circle cx="162" cy="125" r="8" fill={colors.armColor} data-id="element-3370" data-mp="1bzz0tkfuxwhy" />
      </g>;
  switch (emotion) {
    case 'pointing':
      return <>
          <g className="djay-arm-left" data-id="element-3371" data-mp="170w6ov1f1aor">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3372" data-mp="1lxmzglgl3o5e" />
            
          </g>
          <g className="djay-arm-right" style={{
          transformOrigin: '150px 120px'
        }} data-id="element-3373" data-mp="1gzlge0j5rotx">
            
            <ellipse cx="165" cy="120" rx="22" ry="12" fill={colors.armColor} transform="rotate(-10 165 120)" data-id="element-3374" data-mp="37uj3qlrapfnq" />
            
            <path d="M175 118 L192 115" stroke={colors.armColor} strokeWidth="10" strokeLinecap="round" data-id="element-3375" data-mp="3cu5jb1ulj7zp" />
            
            <path d="M175 118 L192 115" stroke={colors.armHighlight} strokeWidth="4" strokeLinecap="round" data-id="element-3376" data-mp="3lspuzj1qohef" />
            
            <ellipse cx="170" cy="118" rx="8" ry="6" fill={colors.armHighlight} transform="rotate(-10 170 118)" data-id="element-3377" data-mp="3qsc4piiczfih" />
            
          </g>
        </>;
    case 'celebrating':
    case 'excited':
    case 'proud':
      return <>
          <g className="djay-arm-left" data-id="element-3378" data-mp="4crhzp3r5rxz">
            <ellipse cx="40" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(35 40 90)" data-id="element-3379" data-mp="8dti085hu810" />
            
            <ellipse cx="32" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(35 32 75)" data-id="element-3380" data-mp="ddfuughetm9a" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3381" data-mp="iciq597l8e42">
            <ellipse cx="160" cy="90" rx="14" ry="25" fill={colors.armColor} transform="rotate(-35 160 90)" data-id="element-3382" data-mp="2ef5d54xvt9v3" />
            
            <ellipse cx="168" cy="75" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-35 168 75)" data-id="element-3383" data-mp="29gkjjod4xofm" />
            
          </g>
        </>;
    case 'thinking':
      return <>
          <g className="djay-arm-left" data-id="element-3384" data-mp="2jei6m8j9df6n">
            <ellipse cx="42" cy="135" rx="14" ry="18" fill={colors.armColor} transform="rotate(15 42 135)" data-id="element-3385" data-mp="2jcnn8ynmxv4o" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3386" data-mp="2x7houiafdnhw">
            <ellipse cx="135" cy="135" rx="14" ry="22" fill={colors.armColor} transform="rotate(-45 135 135)" data-id="element-3387" data-mp="2t4tgebpmiilg" />
            
            <ellipse cx="125" cy="120" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-45 125 120)" data-id="element-3388" data-mp="373ay9ssul0vg" />
            
          </g>
        </>;
    case 'surprised':
      return <>
          <g className="djay-arm-left" data-id="element-3389" data-mp="1cql5xfi4nzq6">
            <ellipse cx="30" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(-20 30 125)" data-id="element-3390" data-mp="17qoy156b7o5c" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3391" data-mp="3jdsh2i2ookxo">
            <ellipse cx="170" cy="125" rx="18" ry="14" fill={colors.armColor} transform="rotate(20 170 125)" data-id="element-3392" data-mp="3jg58dluc07ne" />
            
          </g>
        </>;
    case 'sleeping':
      return <>
          <g className="djay-arm-left" data-id="element-3393" data-mp="39npnafnqn2ya">
            <ellipse cx="55" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(20 55 145)" data-id="element-3394" data-mp="3en2c35y66k3i" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3395" data-mp="30mj41ytpfe1c">
            <ellipse cx="145" cy="145" rx="16" ry="12" fill={colors.armColor} transform="rotate(-20 145 145)" data-id="element-3396" data-mp="30pnfnh9i1c21" />
            
          </g>
        </>;
    case 'encouraging':
      return <>
          <g className="djay-arm-left" data-id="element-3397" data-mp="2qrhi1buq6s2z">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3398" data-mp="2vny3tzegcucw" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3399" data-mp="oyjjcze9p5a4">
            <ellipse cx="165" cy="135" rx="20" ry="14" fill={colors.armColor} transform="rotate(-15 165 135)" data-id="element-3400" data-mp="tx4jkytiroyk" />
            
            <ellipse cx="175" cy="130" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-15 175 130)" data-id="element-3401" data-mp="2q0rcpqm29bnw" />
            
          </g>
        </>;
    case 'happy':
    default:
      return <>
          <g className="djay-arm-left" data-id="element-3402" data-mp="2gyryf62fklon">
            <ellipse cx="42" cy="125" rx="18" ry="22" fill={colors.armColor} transform="rotate(-20 42 125)" data-id="element-3403" data-mp="2gxqaw248a6q1" />
            
            <ellipse cx="38" cy="118" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(-20 38 118)" data-id="element-3404" data-mp="2c2uekprykx74" />
            
          </g>
          <g className="djay-arm-right" data-id="element-3405" data-mp="22aewlsgnw8m8">
            <ellipse cx="158" cy="130" rx="18" ry="22" fill={colors.armColor} transform="rotate(15 158 130)" data-id="element-3406" data-mp="228kcuhh4mmjq" />
            
            <ellipse cx="154" cy="123" rx="8" ry="10" fill={colors.armHighlight} transform="rotate(15 154 123)" data-id="element-3407" data-mp="1t9z052yc61qv" />
            
          </g>
        </>;
  }
}